var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_3500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0755 21.1729C16.8652 21.1729 21.5753 16.4625 21.5753 10.6728C21.5753 4.88319 16.8652 0.172852 11.0755 0.172852C5.28593 0.172852 0.575684 4.88319 0.575684 10.6728C0.575684 16.4625 5.28593 21.1729 11.0755 21.1729ZM11.0755 1.61022C16.0726 1.61022 20.1379 5.67566 20.138 10.6728C20.138 15.6699 16.0727 19.7354 11.0755 19.7355C6.07849 19.7354 2.01314 15.6699 2.01314 10.6727C2.01314 5.67576 6.07849 1.61022 11.0755 1.61022Z",
    fill: "#f4694b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.66532 15.1699C9.80012 15.3046 9.9829 15.3803 10.1735 15.3803C10.3641 15.3803 10.5468 15.3046 10.6816 15.1699C10.7484 15.1032 10.8014 15.0239 10.8375 14.9367C10.8736 14.8495 10.8922 14.756 10.8922 14.6616C10.8922 14.5672 10.8736 14.4738 10.8374 14.3865C10.8013 14.2993 10.7483 14.2201 10.6815 14.1534L7.91988 11.3918L15.9171 11.3911C16.1077 11.391 16.2905 11.3153 16.4253 11.1805C16.56 11.0457 16.6357 10.8629 16.6357 10.6723C16.6357 10.4817 16.56 10.2989 16.4252 10.1642C16.2904 10.0294 16.1076 9.95369 15.917 9.9537L7.9195 9.95446L10.6818 7.19233C10.8166 7.05754 10.8924 6.87473 10.8924 6.68411C10.8924 6.49349 10.8167 6.31067 10.6819 6.17587C10.5471 6.04107 10.3643 5.96534 10.1737 5.96533C9.98303 5.96532 9.80021 6.04104 9.66542 6.17582L5.67635 10.1648C5.60959 10.2315 5.55663 10.3107 5.52051 10.3979C5.48439 10.4851 5.4658 10.5786 5.46582 10.673C5.46592 10.8636 5.54167 11.0464 5.67644 11.1813L9.66532 15.1699Z",
    fill: "#f4694b"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_3500"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "translate(0.575195 0.172852)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/Back.b1e759d539d668983c6786a81436b2a8.svg";
export { ForwardRef as ReactComponent };